import React from "react";
//Material imports
import { useTheme } from "@mui/material/styles";
import GroupIcon from "@mui/icons-material/Stars";
import Typography from "@mui/material/Typography";
//Limitless imports
import { HeaderIconButton } from "@limitless/portal";
import { useManagerProfileContext } from "../../../../manager/hooks";
const ProdGroupsHeaderItem = () => {
  const {
    palette
  } = useTheme();
  const {
    updateBooleanProperty,
    managerProfile
  } = useManagerProfileContext();
  const {
    showNonProdGroups,
    disableChanges
  } = managerProfile;
  const handleChangeSetting = React.useCallback(() => {
    updateBooleanProperty("showNonProdGroups", !showNonProdGroups);
  });
  const color = disableChanges ? palette.disabled : palette.primary.contrastText;
  const icon = /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(GroupIcon, {
    style: {
      pointerEvents: "none",
      color
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      marginLeft: 8,
      color
    }
  }, showNonProdGroups ? "all" : "prod"));
  return /*#__PURE__*/React.createElement(HeaderIconButton, {
    buttonId: "prodGroupsButton",
    onButtonClick: handleChangeSetting,
    tooltip: showNonProdGroups ? "Show Prod Groups" : "Show All Groups",
    icon: icon,
    disabled: disableChanges
  });
};
export default ProdGroupsHeaderItem;